import { mergeWindowingConfig } from '@src/editor/lib/TimelineWindowFilter';
import { LogManager } from '@src/utility/Logger';
import { useEffect } from 'react';

import type {
  TimelineWindowingFeatureFlag,
  WindowingConfig,
} from '@src/editor/lib/TimelineWindowFilter';

const logger = LogManager.getLogger('hook:useWindowingConfig');

/** Narrow interface – any object that exposes `setWindowingConfig`. */
interface WindowingConfigurable {
  setWindowingConfig(config: WindowingConfig): void;
}

interface WindowingFlags {
  initialized: boolean;
  creatorStudioTimelineWindowingConfig?: TimelineWindowingFeatureFlag;
}

/**
 * Synchronises LaunchDarkly timeline-windowing flags to an editor store.
 *
 * Accepts a narrow `WindowingConfigurable` shape so it works with both
 * `EditorStore` and `ClipPreviewEditorStore` without importing concrete types.
 */
export function useWindowingConfig(
  editorStore: WindowingConfigurable | undefined | null,
  flags: WindowingFlags,
): void {
  useEffect(() => {
    if (!flags.initialized || !editorStore) return;

    const merged = mergeWindowingConfig(
      flags.creatorStudioTimelineWindowingConfig,
    );

    logger.debug('Applying windowing config', {
      raw: flags.creatorStudioTimelineWindowingConfig,
      merged,
    });

    editorStore.setWindowingConfig(merged);
  }, [editorStore, flags]);
}
